import styled from 'styled-components';

import hhLogo from '../../assets/icons/icon_healthhub-dark.png';

import { BetweenLayout } from './BetweenLayout';

export const SectionHeading = styled.div`
  align-self: baseline;
  font-size: 16px;
  font-weight: 700;
  color: ${p => 'var(--HScan_Light_Blue, #2e5be0)' ?? p.theme.colors.black2};
`;

export const Divider = styled.div`
  margin: 16px 0px;
  width: 100%;
  height: 0px;
  border-bottom: 1px solid ${p => p.theme.colors.gray3};
`;

export const SectionContentContainer = styled.section<{
  $minHeight?: string;
}>`
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  width: 100%;
  min-height: ${p => p.$minHeight ?? 'max-content'};
  padding: 50px 21px 40px 21px;
  background: #ffffff;
  border: 1px solid #f2f2f2;
  box-shadow: 0px 6px 9px -5px rgba(186, 186, 186, 0.15);
  border-radius: 14px;

  & + & {
    margin-top: 18px;
  }

  ${p =>
    p.theme.isMobile &&
    `
    padding: 0;
    border: none;
    background: none;
    box-shadow: none;

    & + & {
      margin-top: 38px;
    }
    `}
`;

export const TermText = styled.span`
  font-weight: 500;
  font-size: 12px;
  color: #5a6473;
  word-break: keep-all;
`;

export const Tabs = styled.ul<{ $marginTop?: string }>`
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: stretch;
  width: 100%;
  margin: 0;
  margin-top: ${p => p.$marginTop ?? 'unset'};
  padding: 0;
  list-style: none;

  font-family: 'Poppins';
  font-style: normal;
  font-size: 16px;
`;

export const Tab = styled.li<{
  $width?: string;
  $selected?: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${p => p.$width ?? 'auto'};
  box-sizing: border-box;
  padding: 11px 10px;
  cursor: pointer;
  border-style: solid;
  border-width: 1px 1px ${p => (p.$selected ? '0px' : '1px')} 1px;
  border-color: #e7e7e7;
  border-radius: 4px 4px 0px 0px;
  text-align: center;
  word-break: keep-all;

  font-size: 15px;
  line-height: 24px;
  color: ${p =>
    p.$selected
      ? 'var(--HScan_Light_Blue, #2e5be0)'
      : 'var(--HPACS_Text_Light_Grey, #a3a6ab)'};
  background-color: ${p => (p.$selected ? '#ffffff' : '#f5f5f5')};
  font-weight: ${p => (p.$selected ? 700 : 400)};
`;

export const ImageListTop = styled(BetweenLayout)`
  margin-top: 44px;
  margin-bottom: 28px;

  ${p =>
    p.theme.isMobile &&
    `
    margin-bottom: 12px;
    `}
`;

export const PriceTableTop = styled(BetweenLayout)`
  margin-top: 37px;
  padding: 10px 0;

  ${p =>
    p.theme.isMobile &&
    `
    margin-top: 0px;
    `}
`;

export const CurrentTimeTextLayout = styled(BetweenLayout)`
  margin-top: 16px;
  margin-bottom: 12px;
`;

export const CurrentTimeText = styled.span`
  font-size: 12px;
  font-weight: 400;
  color: var(--HPACS_Text_Light_Grey, #a3a6ab);
`;

export const Message = styled.span`
  min-width: 80px;
  flex-shrink: 0;
  height: 24px;
  line-height: 16px;
  box-sizing: border-box;
  text-align: center;
  white-space: nowrap;
  padding: 5px 10px;
  font-size: 12px;
  border-radius: 500px;

  ${p => p.onClick && 'cursor: pointer;'}
`;

export const GreenStatusMessage = styled(Message)`
  color: #2cc56f;
  background: #e6f6e9;
`;

export const BlueStatusMessage = styled(Message)`
  color: #2e5be0;
  background: #2e5be01a;
`;

export const RedStatusMessage = styled(Message)`
  color: #e97103;
  background: #e9710333;
`;

export const GreyStatusMessage = styled(Message)`
  color: #7a7a7e;
  background: #e7e7e7;
`;
export const HealthHubLogo = styled.div`
  width: 206px;
  height: 37px;
  margin-top: 53px;
  background-image: url(${hhLogo});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
`;

export const HospitalNameLogo = styled.div`
  width: 400px;
  margin-top: 53px;
  color: #233251;
  font-weight: 700;
  font-size: 37px;
  line-height: 37px;
  text-align: center;
  word-break: keep-all;
`;
